import React, { useContext, useState, useEffect, useMemo, useCallback } from 'react'
import { useFormik } from 'formik'
import { useHistory } from 'react-router-dom'
import { Checkbox, styled } from '@material-ui/core'

import PrimaryButton from '@/product/components/atoms/PrimaryButton'
import AuthContext from '@/product/context/auth/authContext'
import CustomCommonContext from '@/custom/context/common/commonContext'
import UserContext from '@/product/context/user/userContext'
import ProductCommonContext from '@/product/context/common/commonContext'
import AlertContext from '@/product/context/alert/alertContext'

const SavedSearchBody = () => {
    const history = useHistory()
    const authContext = useContext(AuthContext)
    const userContext = useContext(UserContext)
    const productCommonContext = useContext(ProductCommonContext)
    const { allCategory } = useContext(CustomCommonContext)
    const { setAlert } = useContext(AlertContext)

    const { isAuthenticated, user } = authContext
    const { updateProfile, responseStatus, clearResponse } = userContext
    const { setSearchValue } = productCommonContext

    const [category, setCategory] = useState([])
    const [checkedItems, setCheckedItems] = useState({})

    const CustomCheckbox = styled(Checkbox)({
        '&.MuiCheckbox-root': {
            borderRadius: 5,
            border: '2px solid black',
            padding: 0,
            width: 24,
            height: 24,
            marginLeft: 10,
        },
        '&.Mui-checked': {
            color: 'black',
        },
        '& .MuiSvgIcon-root': {
            fontSize: 28,
        },
    })

    const WavyCheckIcon = () => (
        <img className="tickMark" src="/assets/images/tickMark.svg" alt="Checked" />
    )

    useEffect(() => {
        if (allCategory.length) {
            const sortedCategories = allCategory
                .sort((a, b) => a.show_order - b.show_order)
                .map((lot) => ({
                    id: lot.id.toString(),
                    description: lot.description,
                    avatar: lot.avatar,
                }))
            setCategory(sortedCategories)
        }
    }, [allCategory])

    const handleSearchRedirect = (categories) => {
        const selectedCategories = categories.filter((cat) => checkedItems[cat])
        if (selectedCategories.length === 0) return

        const searchParams = new URLSearchParams()
        selectedCategories.forEach((cat) => {
            searchParams.append('category', cat)
        })

        history.push({
            pathname: '/search',
            search: searchParams.toString(),
        })
    }

    const formikSelection = useFormik({
        initialValues: {
            id: user?.id,
            interested_categories: [],
        },
        onSubmit: (values) => {
            const selectedCategories = Object.keys(checkedItems).filter((key) => checkedItems[key])

            updateProfile(
                {
                    ...values,
                    interested_categories: selectedCategories.join(','),
                },
                true,
            )
            setAlert('Category Updated Successfully', 'success')
            handleSearchRedirect(selectedCategories)
        },
    })

    useEffect(() => {
        if (isAuthenticated && user?.interested_categories) {
            const initialChecked = user.interested_categories
                .toString()
                .split(',')
                .reduce((acc, categoryId) => {
                    acc[categoryId] = true
                    return acc
                }, {})
            setCheckedItems(initialChecked)
            formikSelection.values.id = user.id
        }
    }, [user, isAuthenticated])

    const handleCheckboxChange = useCallback((id, checked) => {
        setCheckedItems((prev) => ({
            ...prev,
            [id]: checked,
        }))
    }, [])

    const categoryDisplay = useMemo(
        () =>
            category.map((item) => (
                <div className="col-md-3 col-6" key={item.id}>
                    <div className="category-card">
                        <img
                            src={`${global.images_url}${item.avatar}`}
                            alt={item.description}
                            onError={(e) => {
                                e.target.src = '/assets/images/noimage.png'
                                e.target.onerror = null
                            }}
                        />
                        <label className="mt-2">
                            {item.description}
                            <CustomCheckbox
                                checkedIcon={<WavyCheckIcon />}
                                checked={!!checkedItems[item.id]}
                                onChange={(e) => handleCheckboxChange(item.id, e.target.checked)}
                            />
                        </label>
                    </div>
                </div>
            )),
        [category, checkedItems],
    )

    return (
        <div className="dashboardInner">
            <div className="d-flex align-items-center justify-content-between">
                <h1 className="title mb-3">MY INTERESTS</h1>
                <PrimaryButton
                    label="View Products"
                    onClick={() => {
                        const selectedCategories = Object.keys(checkedItems).filter(
                            (key) => checkedItems[key],
                        )

                        handleSearchRedirect(selectedCategories)
                    }}
                    btnSize="small"
                />
            </div>
            <div className="mySavedSearches">
                <div className="catSearch">
                    <h6 className="mb-5 tagLine">
                        View Products based on your Categories of Interest.
                    </h6>
                </div>
                <form onSubmit={formikSelection.handleSubmit} autoComplete="off">
                    <div className="row">{categoryDisplay}</div>
                    <div className="actionButton d-flex justify-content-center align-items-center flex-wrap mt-3">
                        <PrimaryButton
                            id="template_add"
                            type="submit"
                            label="Update"
                            btnSize="ml-2"
                        />
                    </div>
                </form>
            </div>
        </div>
    )
}

export default React.memo(SavedSearchBody)
